import { useEffect, useMemo } from 'react'
import { useSetAtom } from 'jotai'
import { useBulkCapabiltiesQuery } from 'hooks/queries/Capabilities/useCapabiltiesQuery'
import { getAccountCapabilities, getAccountCapabilityRequestFilters } from 'utils/capabilities'
import { accountCapabilitiesAtom } from './atoms/capabilitiesAtoms'

export const useSetAccountCapabilities = (accountReference: string) => {
  const setAccountCapabilitiesAtom = useSetAtom(accountCapabilitiesAtom)

  const accountCapabilityRequest = useMemo(() => {
    if (!!accountReference) {
      return getAccountCapabilityRequestFilters(accountReference)
    }
  }, [accountReference])

  const { data: accountCapabilitiesData, isFetching: isFetchingAccountCapabilities } =
    useBulkCapabiltiesQuery(accountCapabilityRequest, !!accountCapabilityRequest)

  const accountCapabilitiesDetails = useMemo(() => {
    if (!!accountCapabilitiesData && !!accountReference) {
      return getAccountCapabilities(accountReference, accountCapabilitiesData)
    }
  }, [accountReference, accountCapabilitiesData])

  useEffect(() => {
    if (!!accountCapabilitiesDetails && !isFetchingAccountCapabilities) {
      setAccountCapabilitiesAtom(accountCapabilitiesDetails)
    }
  }, [accountCapabilitiesDetails])
}
